<template>
    <div id="alert_table" 
        class="popup-table"
        :class="is_full_height ? 'full-height' : ''"
    >
        <div 
            class="popup-table__wrapper" 
            :class="is_minimize ? 'h-45px' : 'h-100vh'"
            style="min-height: 0;"
        >
            <div 
                class="popup-table__container-title" 
                style="display: flex; flex-direction:row;"
            >
                <h1>{{ alerts.title }}</h1>
                <div>
                    <v-btn
                        v-if="is_full_height"
                        class="maximize-btn"
                        color="white"
                        icon
                        style="display: inline-block;"
                        @click="is_minimize=!is_minimize"
                    >
                        <v-icon color="white">
                            {{ is_minimize ? 'mdi-window-maximize' : 'mdi-window-minimize' }}
                        </v-icon>
                    </v-btn>
                    <v-btn
                        class="close-btn"
                        color="black"
                        icon

                        @click="close_dialog"
                    >
                        <v-icon color="white">
                            mdi-close
                        </v-icon>
                    </v-btn>
                </div>
            </div>
            <div 
                class="popup-table__container" 
                :class="is_minimize ? 'h-0vh' : 'h-100vh'"
            >
                <div class="popup-table__content-wrapper">
                    <template>
                        <div class="popup-table__content one-column">
                            <div 
                                v-for="(datum, index) in alerts.data" 
                                :key="index"
                                class="popup-table__content-item"
                            >
                                <!-- <p v-html="datum"></p> -->
                                <div v-for="([sub_header, content], index) in Object.entries(datum)" 
                                    :key="index"
                                    class="alert-table__content-wrapper"
                                >
                                    <div class="alert-table__sub-header">
                                        {{ sub_header }}
                                    </div>
                                    <div class="alert-table__content">
                                        <p v-html="content" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { transform_timestamp_to_customized_str } from '@/utils/common/custom_time.js'
    import { mapState, mapMutations } from 'vuex'
    export default {
        name: "QpeAlertTable",


        props: {
            props_alerts: {
                type: Object,
                require: true,
                default: () => ({})
            },
        },

        data() {
            return{
                is_minimize: false,
            }
        },

        computed: {
            ...mapState({
                current_timestamp: state => state.emap.current_timestamp,
            }),

            datetime_str() {
                return transform_timestamp_to_customized_str(this.current_timestamp, (datetime_str_obj) => {
                    const {yyyy, mm, dd, HH, MM} = datetime_str_obj
                    return `${yyyy}-${mm}-${dd} ${HH}:${MM}`
                })
            },

            alerts() {
                return this.props_alerts
            },

            is_full_height() {
                return (['天氣概況'].includes(this.props_alerts.title))
            }
        },

        methods: {
            ...mapMutations({
                set_is_show_alert_table: 'emap/set_is_show_alert_table',
            }),

            close_dialog() {
                this.set_is_show_alert_table(false)
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin';
    @import '../../../../css/emap/gis/popup';

    .popup-table .popup-table__wrapper {
        width: 520px;

        @include mobile {
            width: 100%;
        }
    }

    .alert-table {
        &__content-wrapper {
            width: 100%;
            font-family: NotoSansCJKtc;
        }

        &__sub-header {
            margin: .5rem;
            font-size: 20px;
            font-weight: 600;
            letter-spacing: .8px;
            line-height: 1.5;
            text-align: left;
            color: var(--base-blue);
        }

        &__content {
            margin: .5rem;
            letter-spacing: .6px;
            line-height: 1.43;
            color: var(--base_black);
        }
    }
</style>